import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiShoppingCart } from "react-icons/fi";
import { getCart } from "../../api/cartApi";

const buyerRoutes = new Set([
  "/marketplace", "/shoppage", "/shopbuyeformarketplace", "/shpebuye",
  "/customview", "/allsellers", "/productview", "/cart", "/cartpageseller",
  "/addshopperadders", "/addshopperaddress", "/profilecheckout", "/ordereview",
  "/orderreceipt", "/paymentfail", "/myorder", "/my-orders",
]);

export default function MarketplaceCartLink({ className = "" }) {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase().replace(/\/+$/, "");
  const visible = buyerRoutes.has(path) || /^\/(productview|order)\/[^/]+$/.test(path);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!visible) return;
    let active = true;
    let requestId = 0;
    const refresh = async () => {
      const id = ++requestId;
      const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
      if (!token) {
        setCount(0);
        return;
      }
      try {
        const data = await getCart();
        if (active && id === requestId && data.success && data.result) {
          setCount(Number(data.result.summary?.total_quantity) || 0);
        }
      } catch {
        return;
      }
    };
    refresh();
    window.addEventListener("cartUpdated", refresh);
    return () => {
      active = false;
      window.removeEventListener("cartUpdated", refresh);
    };
  }, [visible, pathname]);

  if (!visible) return null;

  return (
    <Link
      to="/cart"
      aria-label={`View cart, ${count} items`}
      title="View Cart"
      className={`relative inline-flex shrink-0 items-center justify-center p-2 rounded-full hover:bg-gray-100 text-gray-700 ${className}`}
    >
      <FiShoppingCart size={28} color="#374151" aria-hidden="true" />
      <span className="absolute -top-1 -right-1 min-w-5 rounded-full bg-red-500 px-1 text-center text-xs font-bold text-white" aria-live="polite" aria-atomic="true">
        {count}
      </span>
    </Link>
  );
}
